export const RECEIVE_CONFIGS = 'RECEIVE_CONFIGS'
export const RECEIVE_CONFIGS_ERROR = 'RECEIVE_CONFIGS_ERROR'
export const REQUEST_SESSION = 'REQUEST_SESSION'
export const REQUEST_CREATE_SESSION = 'REQUEST_CREATE_SESSION'
export const RECEIVE_SESSION = 'RECEIVE_SESSION'
export const SET_SESSION_NONCE = 'SET_SESSION_NONCE'
export const RESET_SESSION = 'RESET_SESSION'
export const RECEIVE_OAUTH_SESSION_ERROR = 'RECEIVE_OAUTH_SESSION_ERROR'
export const RECEIVE_SESSION_ERROR = 'RECEIVE_SESSION_ERROR'
